import { useApolloClient } from '@apollo/client'
import { useLoginHook } from 'hooks'
import { RefreshToken } from 'modules/ApolloClient/services'
import React, { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { getQueryParamsValue } from 'utils'
import { goToPage } from 'redesign/utils/goToPage'
import { FullPageLoading } from 'components'

type RefreshTokenResponse = {
    refreshToken: RefreshToken
}

type RefreshToken = {
    access_token: string
    refresh_token: string
}

const ExternalLogin = () => {
    const { resetAuthState } = useLoginHook()

    const location = useLocation()
    const history = useHistory()
    const client = useApolloClient()

    useEffect(() => {
        localStorage.removeItem('@Livia')
        sessionStorage.removeItem('@Livia/federalTaxId')

        const loginWeb = async () => {
            const token = getQueryParamsValue(location, 'token')
            let redirectPath = getQueryParamsValue(location, 'redirectPath') || '/plataforma/inicio'
            if (redirectPath && !redirectPath.includes('/plataforma/')) {
                redirectPath = `/plataforma${redirectPath}`
            }
            try {
                if (!token) {
                    return history.push(`/entrar?redirectTo=${redirectPath}`)
                }

                const { data } = await client.mutate<RefreshTokenResponse>({
                    context: { headers: {} },
                    mutation: RefreshToken,
                    variables: { token },
                })

                const storageData = {
                    token: data?.refreshToken.access_token,
                    refreshToken: data?.refreshToken.refresh_token,
                    signed: !!data?.refreshToken.access_token,
                    limitedFlow: false,
                }

                resetAuthState()
                localStorage.setItem('@Livia', JSON.stringify(storageData))
                goToPage(redirectPath)
            } catch (error) {
                goToPage('/entrar?origin=sessao-expirada')
            }
        }

        loginWeb()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <FullPageLoading />
}

export default ExternalLogin
